












































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import NotificationTemplateTranslations from "./NotificationTemplateTranslations.vue";
import NotificationTemplateVariables from "./NotificationTemplateVariables.vue";
import RichTextEditor from "@/components/misc/RichTextEditor.vue";
import { NotificationTemplateModel } from "./types";
import { Getter, Action } from "vuex-class";
import { MessageSourceType } from "@/shared/models/messageSourceType";
import { LanguageView } from "@/shared/models/languages";
import { Notification } from "@/store/modules/notifications";
import FormDescription from "@/components/misc/FormDescription.vue";
import NotificationScheduleForm from "../schedules/NotificationScheduleForm.vue";
import { NotificationTemplateAttachment } from "@/shared/models/notificationTemplateAttachment";
import { NotificationTemplateRecipient } from "@/shared/models/notificationTemplateRecipient";
import * as _ from "lodash";
import { MessageSourceTypeEnum } from "../types";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";

@Component({
  components: {
    RichTextEditor,
    NotificationTemplateTranslations,
    NotificationTemplateVariables,
    FormDescription,
    NotificationScheduleForm,
  },
})
export default class NotificationTemplateForm extends Vue {
  @Getter("codebooks/languages")
  languages?: LanguageView[];
  @Action("codebooks/refreshLanguages")
  refreshLanguages?: () => Promise<void>;

  @Getter("codebooks/messageSourceTypes")
  sourceTypes?: MessageSourceType[];
  @Action("codebooks/refreshMessageSourceTypes")
  refreshSourceTypes?: () => Promise<void>;

  @Getter("codebooks/notificationTemplateRecipients")
  recipients?: NotificationTemplateRecipient[];
  @Action("codebooks/refreshNotificationTemplateRecipients")
  refreshRecipients?: () => Promise<void>;

  @Getter("codebooks/notificationTemplateAttachments")
  attachments?: NotificationTemplateAttachment[];
  @Action("codebooks/refreshNotificationTemplateAttachments")
  refreshAttachments?: () => Promise<void>;

  translationsDrawerOpen = false;
  testDialogOpen = false;
  scheduleOpen = false;

  async created() {
    const promises = [];

    if (this.$route.params.id || this.$route.query.copy) {
      const id = this.$route.params.id
        ? Number.parseInt(this.$route.params.id)
        : Number.parseInt(this.$route.query.copy as string);
      this.loadTemplate(id);
    } else {
      this.loadTemplate(null);
    }

    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      promises.push(this.refreshLanguages());
    }

    if ((this.sourceTypes?.length ?? 0) === 0 && this.refreshSourceTypes) {
      promises.push(this.refreshSourceTypes());
    }

    if ((this.recipients?.length ?? 0) === 0 && this.refreshRecipients) {
      promises.push(this.refreshRecipients());
    }

    if ((this.attachments?.length ?? 0) === 0 && this.refreshAttachments) {
      promises.push(this.refreshAttachments());
    }

    await Promise.all(promises);
  }

  loadTemplate(id: number | null) {
    this.loading = true;
    if (id) {
      this.axios
        .get<NotificationTemplateModel>("/notificationTemplates/" + id)
        .then((res) => {
          this.template = { ...res.data };

          if (this.$route.query.copy) {
            this.template.id = 0;
          }

          this.initialTemplate = _.cloneDeep(this.template);
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.template = new NotificationTemplateModel();
      this.initialTemplate = _.cloneDeep(this.template);
      this.loading = false;
    }
  }

  template = new NotificationTemplateModel();
  initialTemplate: NotificationTemplateModel | null = null;

  isFormValid = false;
  isTranslationsFormValid = false;
  useSimpleVariables = false;

  @Watch("template.sourceTypes")
  watchTemplateSourceTypes(fresh: number[]) {
    if(fresh.some(x => x === MessageSourceTypeEnum["SMS"] || x === MessageSourceTypeEnum["WhatsApp"])) {
      this.useSimpleVariables = true;
      this.template.body = this.template.body.replace(/(<([^>]+)>)/ig, '');
    } else {
      this.useSimpleVariables = false;
    }
  }

  get submitDisabled(): boolean {
    return this.isFormValid && this.isTranslationsFormValid && !this.loading;
  }

  get activeSorceTypes() {
    return this.sourceTypes?.filter(x => x.id === MessageSourceTypeEnum.EMail || 
    x.id === MessageSourceTypeEnum.WhatsApp || x.id === MessageSourceTypeEnum.SMS) 
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  get translationsForm(): Vue & { validate: () => boolean } {
    return this.$refs.translationsForm as Vue & { validate: () => boolean };
  }

  loading = false;
  save(overrides: string[]) {
    this.form.validate();
    this.translationsForm.validate();

    if (!this.isFormValid || !this.isTranslationsFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    const handleCodes = ["NotificationTemplates.Validation.MessageTemplateTooManyCharacters"];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const isOverriding = overrides.length !== 0;

    this.loading = true;
    if (!this.template.id) {
      this.axios
        .post("/notificationTemplates", {...this.template, overrideRules: overrides}, {adapter})
        .then((res) => {
          this.saveSuccess();
          this.$router.replace({
            name: "NotificationTemplateEdit",
            params: { id: res.data.toString() },
            replace: true,
          });
        })
        .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)}`,
            timeout: 30000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.save(x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          } as Notification);
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          } as Notification);
        }
      })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.axios
        .put("/notificationTemplates", {...this.template, overrideRules: overrides}, {adapter})
        .then(() => {
          this.saveSuccess();
        })
        .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)}`,
            timeout: 30000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.save(x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          } as Notification);
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          } as Notification);
        }
      })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  saveSuccess() {
    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("NotificationTemplate.SaveSuccess"),
      timeout: 5000,
    } as Notification);

    this.initialTemplate = _.cloneDeep(this.template);
  }

  notificationTestModel = {
    reservationId: null as number | null,
    to: "",
    cultureCode: "",
    sourceTypeId: null as number | null
  };

  get testForm(): Vue & { validate: () => boolean } {
    return this.$refs.testForm as Vue & { validate: () => boolean };
  }
  isTestFormValid = false;
  sendingTest = false;
  submitNotificationTest() {
    if (this.notificationTestModel.reservationId?.toString() === "") {
      this.notificationTestModel.reservationId = null;
    }

    //TODO: make multiple send by source type
    this.notificationTestModel.sourceTypeId = this.template.sourceTypes[0];

    this.sendingTest = true;

    this.axios
      .post("/notificationTemplates/SendTestNotification", {
        ...this.template,
        notificationTemplateId: this.template.id,
        ...this.notificationTestModel,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("NotificationTemplate.TestSentSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.sendingTest = false;
      });
  }

  get rules() {
    return {
      required: (value: any) => (Array.isArray(value) ? !!value.length : !!value) || this.$t("Validation.Required"),
      maxLength: (value: string, max: number) =>
        value.length <= max || this.$t("Validation.MaxLength", { count: max }),
      emailFormat: (value: string) =>
        !value ||
        /^$|.+@.+\..+/.test(value) ||
        this.$t("Validation.EmailFormat"),
    };
  }

  checkClose() {
    if (!this.isUnchanged) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t(
          "Changes pending. Are you sure you want to close the form?"
        ),
        actions: [
          {
            text: this.$t("Yes"),
            fun: () => {
              this.close();
              return true;
            },
          },
          {
            text: this.$t("No"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 5000,
      } as Notification);
    } else {
      this.close();
    }
  }

  close() {
    this.$router.push({ path: "/settings/notification-templates" });
  }

  get isUnchanged(){
    return _.isEqual(this.template, this.initialTemplate);
  }

  scheduleCreated(id: number){
    this.template.notificationScheduleId = id;
    if (this.initialTemplate){
      this.initialTemplate.notificationScheduleId = id;
    }
  }

  scheduleDeleted() {
    this.template.notificationScheduleId = null;
    if (this.initialTemplate) {
      this.initialTemplate.notificationScheduleId = null;
    }

    this.scheduleOpen = false;
  }

  get isSMSOrWhatsApp() {
    return this.template.sourceTypes.some(x => x === MessageSourceTypeEnum["WhatsApp"] || x === MessageSourceTypeEnum["SMS"]);
  }
}
